import React from "react";
import {getModelFactory} from "../../../../ts/model-factory/ModelFactory";
import RouteChoice from "../../../../ts/model-factory/basic/route/RouteChoice";
import RouteChoiceButton from "../../../element/button/RouteChoiceButton";
import StateViewController from "../../../vc/StateViewController";
import {IRouteProps} from "../../../../ts/manager/view/ViewInterface";
import {AccountLoginForm} from "../../../form/account/AccountLoginForm";

const AccountLoginPage = (props:IRouteProps) =>
{

    const viewState = StateViewController({
        routeProps: props,
        redirectOnLogin: true
    })

    if(viewState.overrideView){
        return viewState.overrideView;
    }

    const accountModel = getModelFactory().accountRoute.getDefaultModel();
    const passwordResetChoice: RouteChoice | null = accountModel.choices.password_reset ?? null;
    const registerChoice: RouteChoice | null = accountModel.choices.register ?? null;

    return <>
        <section className="content-block">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        {!!registerChoice && <>
                            <p>
                                New users can create an account <RouteChoiceButton routeChoice={registerChoice}>here</RouteChoiceButton>.
                            </p>
                        </>}
                        {!!passwordResetChoice &&
                            <p>
                                Forgot your password? You can retrieve it <RouteChoiceButton routeChoice={passwordResetChoice}>here</RouteChoiceButton>.
                            </p>
                        }
                    </div>
                </div>
            </div>
            <AccountLoginForm
                routeProps={props}
            />
        </section>
    </>
}

export default AccountLoginPage;